import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/components/config'
import X from '@/components/proposalRules'
import R from '@/components/bookingRules'
// import {auth} from '@/firebase'
// import * as firebase from 'firebase'

Vue.use(Vuex)

// Connection 3 ('/deliverydb/') is root-relative, so it only resolves when the page
// is served by the office IIS server. Checked against a positive allowlist so an
// unrecognised host falls back to the internet route instead of a dead path.
function isLocalServer() {
  return config.localHosts.indexOf(window.location.hostname) !== -1
}

const API_PATHS = {
  api1: config.webPath,
  api2: config.webPath2,
  api3: config.webPath3
}

function apiPath(key) {
  return Object.prototype.hasOwnProperty.call(API_PATHS, key) ? API_PATHS[key] : null
}

// A stored 'api3' from an office session must not leak into a session served from
// Firebase Hosting, where the SPA rewrite answers '/deliverydb/...' with index.html
// at HTTP 200 -- axios would parse HTML as XML and fail like a data bug, not a
// connection bug. Same reason an unknown key falls back rather than passing through.
function initialApi() {
  const stored = localStorage.api
  if (!apiPath(stored)) return 'api1'
  if (stored === 'api3' && !isLocalServer()) return 'api1'
  return stored
}

export default new Vuex.Store({
  state: {
    custom: {status: 'administrator'},
    administrator: null,
    admin: null,
    delivery: null,
    user: null,
    status: '',
    config:config,
    currentApi:initialApi(),
    // Every stored identity -> full name (people.buildDirectory), and every email
    // the signed-in account has had (people.identitiesOf). Filled by App.vue.
    directory: {},
    identities: [],
    // The whole userProfile directory (for proposalRules.canDecide, which needs
    // the caller's and the owner's group) and every open propose-and-confirm
    // request. Both filled by App.vue.
    profiles: [],
    proposals: []
  },
  mutations: {
    setAdministrator(state){
      state.status = 'administrator'
    },
    setAdmin(state){
      state.status = 'admin'
    },
    setDelivery(state){
      state.status = 'delivery'
    },
    setRole(state,payload){
      state.status = payload
    }
    ,
    setUser(state, payload){
      state.user = payload
    },
    clearUser(state){
      // state.user = 'user'
      state.user = null
    },
    clearRole(state){
      state.status = null
    },
    setDirectory(state, map){
      state.directory = map || {}
    },
    setIdentities(state, list){
      state.identities = list || []
    },
    clearDirectory(state){
      state.directory = {}
      state.identities = []
      state.profiles = []
      state.proposals = []
    },
    setProfiles(state, list){
      state.profiles = list || []
    },
    setProposals(state, rows){
      state.proposals = rows || []
    },
    setApi(state, api) {
      state.currentApi = api;
      localStorage.setItem('api', api);
    },
  },
  actions: {

  },
  getters:{
    administrator(state){
      return state.administrator
    },
    admin(state){
      return state.admin
    },
    user(state){
      return state.user
    },
    // Until the directory arrives, the current email alone -- so ownership never
    // reads as "nobody", only briefly as "current email only".
    identities(state){
      if (state.identities.length) return state.identities
      return state.user ? [state.user] : []
    },
    isLocalServer() {
      return isLocalServer()
    },
    webPath(state) {
      return apiPath(state.currentApi) || state.config.webPath
    },
    // Work waiting on this user: proposals they may decide and rejections they
    // should phone about. 0 for a driver (proposalRules.badgeCount).
    proposalBadge(state, getters){
      return X.badgeCount(state.proposals, {
        role: state.status,
        identities: getters.identities,
        user: state.user,
        profiles: state.profiles,
        today: R.todayStr()
      })
    },
  }
})
